import React from 'react';
import { AppointmentsView } from "../components/AppointmentsView";
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';

export default function AgendaPage() {
  const { masterDb, activeBusinessId } = useBusinessStore();
  const { userRole } = useAuthStore();
  
  const activeBusiness = masterDb.find(b => String(b.id) === String(activeBusinessId));
  const isImpersonating = userRole === 'master' && activeBusinessId;

  if (!activeBusiness) return <div>Cargando...</div>;

  return (
    <AppointmentsView negocioId={isImpersonating ? activeBusinessId : activeBusiness.id} />
  );
}
